module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-generator"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('mu-content-block', [_c('h1', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("Meal plan generator")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "8px",
      "margin-bottom": "24px"
    }
  }, [_vm._v("Generate a meal plan from hundreds of delicious recipes in our\n        database.")])])], 1), _vm._v(" "), (!_vm.isMealPlanShown) ? _c('div', {
    staticClass: "content"
  }, [_c('mu-card', [_c('mu-card-text', [_c('meal-plan-filter-modal', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    on: {
      "change": _vm.filtersSet
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("Which days do you want to plan for")]), _vm._v(" "), _vm._l((_vm.model.days), function(day, index) {
    return _c('mu-float-button', {
      key: 'day-' + index,
      staticClass: "day-button outline",
      class: {
        'active': _vm.model.availableDays.includes(day.name)
      },
      staticStyle: {
        "margin": "4px"
      },
      attrs: {
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addToAvailableDays(day.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.label) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label",
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n          Which meals do you want to plan for?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "align-icon-right",
    attrs: {
      "full-width": "",
      "label": "Breakfast",
      "label-position": "before",
      "icon": "radio_button_unchecked",
      "icon": _vm.model.availableMeals.includes('BREAKFAST') ? 'radio_button_checked' : 'radio_button_unchecked'
    },
    on: {
      "click": function($event) {
        return _vm.toggleMeal('BREAKFAST')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "align-icon-right",
    attrs: {
      "full-width": "",
      "label": "Lunch",
      "label-position": "before",
      "icon": "radio_button_unchecked",
      "icon": _vm.model.availableMeals.includes('LUNCH') ? 'radio_button_checked' : 'radio_button_unchecked'
    },
    on: {
      "click": function($event) {
        return _vm.toggleMeal('LUNCH')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "align-icon-right",
    attrs: {
      "full-width": "",
      "label": "Dinner",
      "label-position": "before",
      "icon": _vm.model.availableMeals.includes('DINNER') ? 'radio_button_checked' : 'radio_button_unchecked'
    },
    on: {
      "click": function($event) {
        return _vm.toggleMeal('DINNER')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_vm._v("\n          How many people are you planning for?\n        ")]), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('mu-col', {
    attrs: {
      "align": "left",
      "width": "15"
    }
  }, [_c('mu-float-button', {
    staticClass: "incrementor-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.decrementServings.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "remove_circle_outline"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "center",
      "width": "70"
    }
  }, _vm._l((_vm.model.servingslte), function(item, sin) {
    return _c('img', {
      key: 'serving-' + sin,
      staticStyle: {
        "margin": "8px"
      },
      attrs: {
        "src": "static/ic_male.png"
      }
    })
  }), 0), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "right",
      "width": "15"
    }
  }, [_c('mu-float-button', {
    staticClass: "incrementor-btn",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.incrementServings.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "add_circle_outline"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "24px"
    }
  }, [_c('mu-col', {
    attrs: {
      "align": "left",
      "width": "33"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "center",
      "width": "33"
    }
  }, [_vm._v(_vm._s(_vm.model.servingslte) + " people")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "align": "right",
      "width": "33"
    }
  })], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "full-width": "",
      "secondary": "",
      "label": "Create plan"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.generateMealPlans.apply(null, arguments)
      }
    }
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMealPlanShown) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "left",
      "margin-bottom": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-self": "center"
    }
  }, _vm._l((_vm.model.days), function(day, dayIndex) {
    return (_vm.model.availableDays.includes(day.name)) ? _c('mu-float-button', {
      key: 'shown-day-' + dayIndex,
      staticClass: "day-button",
      class: {
        'activeDay': day.name === _vm.activeDay,
        'faded': !_vm.daySatisfied(day)
      },
      staticStyle: {
        "margin": "2px"
      },
      attrs: {
        "mini": "",
        "label": "M"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setDay(day.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.label) + "\n        ")]) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-row', [_c('mu-col', [_c('meal-plan-filter-modal')], 1), _vm._v(" "), _c('mu-col')], 1)], 1), _vm._v(" "), (_vm.model.availableMeals.includes('BREAKFAST')) ? _c('meal-plan-panel', {
    attrs: {
      "allergies": _vm.allergyCsv,
      "filters": _vm.filters,
      "dietaryTypes": _vm.dietaryTypesList().join(','),
      "activeDay": _vm.activeDay,
      "type": "breakfast",
      "recipe": _vm.activeBreakfastForDay
    },
    on: {
      "changed": _vm.pushToBreakfast
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.availableMeals.includes('LUNCH')) ? _c('meal-plan-panel', {
    attrs: {
      "allergies": _vm.allergyCsv,
      "filters": _vm.filters,
      "dietaryTypes": _vm.dietaryTypesList().join(','),
      "activeDay": _vm.activeDay,
      "type": "lunch",
      "recipe": _vm.activeLunchForDay
    },
    on: {
      "changed": _vm.pushToLunch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.availableMeals.includes('DINNER')) ? _c('meal-plan-panel', {
    attrs: {
      "allergies": _vm.allergyCsv,
      "filters": _vm.filters,
      "dietaryTypes": _vm.dietaryTypesList().join(','),
      "activeDay": _vm.activeDay,
      "type": "dinner",
      "recipe": _vm.activeDinnerForDay
    },
    on: {
      "changed": _vm.pushToDinner
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "disabled": !_vm.satisfiedDays,
      "label": "Create plan"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openMealPlanModal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "title": "Give your meal plan a name"
    },
    on: {
      "close": function($event) {
        _vm.dialogOpen = false
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveMealPlan.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    attrs: {
      "full-width": "",
      "label": "Name",
      "hint-text": "Enter a name for your meal plan"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.cancelText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "type": "button",
      "primary": "",
      "label": _vm.$t('message.okText')
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveMealPlan.apply(null, arguments)
      }
    },
    slot: "actions"
  })], 1)], 1)])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-448637f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/MealPlanGenerator/Index.vue
// module id = 3146
// module chunks = 1